import { axiosInstance as axios } from "@/utils/wd_axios.js";
import { wdConfigData } from "./wd_app_config.js";

// walletTransaction/list
export const wd_getTransactionList = () => {
  var url = `${wdConfigData.baseURLGds}/walletTransaction/list`;
  return axios.get(url);
};

// // Accounts/SignIn
// // Post
// // accountName, password, accountType,
// export const wd_globalSignIn = (params) => {
//   var requestBody = {
//     account: params.accountName,
//     password: params.password,
//     authType: params.loginType,
//   };
//   var url = `${wdConfigData.baseURLGds}/sysAuth/login`;
//   console.log("url =", url);
//   return axios.post(url, requestBody, {});
// };
